import { animated, useSpring } from 'react-spring';
import {
  getCurrentAdminPanelsHistoryEntry,
  getSiteViewportFullscreen,
} from '../../../selectors';
import { AdminPanelContainerProps } from './admin-panel-container-props';
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const WIDTH = 360;

export const AdminPanelContainerComponent = React.forwardRef<
  HTMLDivElement,
  AdminPanelContainerProps
>(
  (props, ref): React.ReactElement => {
    const { children, style, theme, ...rest } = props;

    const currentPanelEntry = useSelector(getCurrentAdminPanelsHistoryEntry);
    const isFullscreen = useSelector(getSiteViewportFullscreen);

    const { marginLeft } = useSpring({
      to: {
        marginLeft: isFullscreen ? -WIDTH : 0,
      },
    }) as any;

    return (
      <animated.aside
        {...rest}
        style={{
          ...style,
          marginLeft: marginLeft.interpolate(
            (v: number): string => `${Math.round(v)}px`,
          ),
        }}
        ref={ref}
      >
        {children}
      </animated.aside>
    );
  },
);

AdminPanelContainerComponent.displayName = 'AdminPanelContainer';

export const AdminPanelContainer = styled(AdminPanelContainerComponent)`
  backface-visibility: hidden;
  order: 1;
  position: relative;
  width: ${WIDTH}px;
  z-index: 1;
`;
